// extracted by mini-css-extract-plugin
export default {"p_tye":"_21a8540899","slcted":"_169ff1eabc","slc_color":"_96a6770534","item_p":"ea374d0122","r0":"e6b2cc5c09"};